









































































































































































































































































































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { ModeloDeEtiqueta, CampoDeEtiquetaDisponivel } from '@/models/ModeloDeEtiqueta'
import { GrupoEconomico } from '@/models/GrupoEconomico'
import { TamanhoDaEtiqueta } from '@/models/EtiquetaDePreco'
import SeletorDeGruposEconomicos from '@/components/loja/SeletorDeGruposEconomicos.vue'
import SeletorDeTamanhosDeEtiqueta from './SeletorDeTamanhosDeEtiqueta.vue'
import EditorDeLayoutDeEtiqueta from './EditorDeLayoutDeEtiqueta.vue'
import PreviaDeImpressaoDeEtiqueta from './PreviaDeImpressaoDeEtiqueta.vue'
import { ModeloDeEtiquetaUseCase } from '@/usecases'

const LARGURA_MAXIMA_DA_PREVIA_PX = 460
const ALTURA_MAXIMA_DA_PREVIA_PX = 540
const RASCUNHO_MODELO_DE_ETIQUETA = 'RASCUNHO_MODELO_DE_ETIQUETA'

interface RascunhoDeModelo {
	modelo: ModeloDeEtiqueta
	editando: boolean
	etapa: string | number
}

@Component({
	components: {
		SeletorDeGruposEconomicos,
		SeletorDeTamanhosDeEtiqueta,
		EditorDeLayoutDeEtiqueta,
		PreviaDeImpressaoDeEtiqueta,
	},
})

export default class DialogoDeEdicaoModeloDeEtiqueta extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeDescricao!: HTMLInputElement
	@Ref() seletorDeTamanhos!: SeletorDeTamanhosDeEtiqueta

	modelo: ModeloDeEtiqueta | null = null
	camposDisponiveis: CampoDeEtiquetaDisponivel[] = []
	obrigatorio = obrigatorio
	mostra = false
	editando = false
	salvando = false
	etapa: string | number = '1'
	snapshotInicial: string | null = null
	dialogoDeFechamentoComAlteracoes = false
	tamanhoOriginalSelecionado: TamanhoDaEtiqueta | null = null
	dialogoDeSobrescritaDeTamanho = false
	acaoSobrescritaDeTamanho: 'sobrescrever' | 'copia' = 'copia'
	nomeDaCopiaDeTamanho = ''
	tabelasSimuladas = 1

	modeloDeEtiquetaUseCase = new ModeloDeEtiquetaUseCase()

	created() {
		try {
			const bruto = localStorage.getItem(RASCUNHO_MODELO_DE_ETIQUETA)
			if (!bruto) return
			const rascunho: RascunhoDeModelo = JSON.parse(bruto)
			this.modelo = rascunho.modelo
			this.editando = rascunho.editando
			this.etapa = rascunho.etapa
			this.mostra = true
			this.tamanhoOriginalSelecionado = (this.modelo && this.modelo.tamanho && this.modelo.tamanho.id)
				? { ...this.modelo.tamanho }
				: null
			this.snapshotInicial = JSON.stringify(this.modelo)
			this.carregarCamposDisponiveisSeNecessario()
		} catch {
			localStorage.removeItem(RASCUNHO_MODELO_DE_ETIQUETA)
		}
	}

	async carregarCamposDisponiveisSeNecessario() {
		if (this.camposDisponiveis.length > 0) return
		try {
			this.camposDisponiveis = await this.modeloDeEtiquetaUseCase.listarCamposDisponiveis()
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async mostrar(modelo: ModeloDeEtiqueta | null, editando: boolean) {
		this.modelo = JSON.parse(JSON.stringify(modelo))
		this.mostra = true
		this.editando = editando
		this.etapa = '1'
		this.dialogoDeSobrescritaDeTamanho = false
		this.tamanhoOriginalSelecionado = (this.modelo && this.modelo.tamanho && this.modelo.tamanho.id)
			? { ...this.modelo.tamanho }
			: null

		if (!editando && this.modelo && !this.modelo.tamanho) {
			this.criarTamanhoEmBranco()
		}

		this.snapshotInicial = JSON.stringify(this.modelo)

		await this.carregarCamposDisponiveisSeNecessario()

		setTimeout(() => {
			this.form.resetValidation()
			this.campoDeDescricao.focus()
		})
	}

	@Watch('modelo', { deep: true })
	@Watch('editando')
	@Watch('etapa')
	salvarRascunho() {
		if (!this.mostra || !this.modelo) return
		localStorage.setItem(RASCUNHO_MODELO_DE_ETIQUETA, JSON.stringify({
			modelo: this.modelo,
			editando: this.editando,
			etapa: this.etapa,
		}))
	}

	@Watch('mostra')
	onMostraChange(aberto: boolean) {
		if (!aberto) localStorage.removeItem(RASCUNHO_MODELO_DE_ETIQUETA)
	}

	get houveAlteracoesNaoSalvas(): boolean {
		return this.mostra && this.modelo !== null && JSON.stringify(this.modelo) !== this.snapshotInicial
	}

	mounted() {
		window.addEventListener('keydown', this.aoPressionarTecla)
	}

	beforeDestroy() {
		window.removeEventListener('keydown', this.aoPressionarTecla)
	}

	aoPressionarTecla(evento: KeyboardEvent) {
		if (evento.key !== 'Escape') return
		if (!this.mostra || this.dialogoDeSobrescritaDeTamanho || this.dialogoDeFechamentoComAlteracoes) return
		this.tentarFechar()
	}

	tentarFechar() {
		if (this.houveAlteracoesNaoSalvas) {
			this.dialogoDeFechamentoComAlteracoes = true
			return
		}
		this.fecharDeFato()
	}

	fecharDeFato() {
		this.modelo = null
		this.mostra = false
		this.dialogoDeFechamentoComAlteracoes = false
	}

	get podeEditarTamanhoDeEtiqueta() {
		return UserLoginStore.permiteRegraDeNegocio('pode-editar-criar-tamanho-de-etiqueta')
	}

	maiorQueZero(valor: number): string | boolean {
		return valor > 0 || 'Deve ser maior que zero'
	}

	naoNegativo(valor: number): string | boolean {
		return (valor !== null && valor !== undefined && valor >= 0) || 'Obrigatório'
	}

	novoTamanho() {
		if (!this.podeEditarTamanhoDeEtiqueta) return
		this.criarTamanhoEmBranco()
	}

	criarTamanhoEmBranco() {
		if (!this.modelo) return
		this.modelo.tamanho = {
			id: '',
			descricao: '',
			grupoEconomico: this.modelo.grupoEconomico || null,
			impressaoUnica: false,
			larguraPagina: 0,
			alturaPagina: 0,
			larguraEtiqueta: 0,
			alturaEtiqueta: 0,
			bordaEsquerda: 0,
			distanciaEntreEtiquetas: 0,
			bordaDoTopo: 0,
		}
	}

	@Watch('modelo.grupoEconomico')
	onTrocarGrupoEconomicoDoModelo(novoGrupo: GrupoEconomico | null, grupoAnterior: GrupoEconomico | null) {
		if (!this.modelo || !this.modelo.tamanho) return
		if ((grupoAnterior && grupoAnterior.id) === (novoGrupo && novoGrupo.id)) return

		if (!this.modelo.tamanho.id) {
			this.modelo.tamanho.grupoEconomico = novoGrupo
			return
		}

		if (this.modelo.tamanho.grupoEconomico && this.modelo.tamanho.grupoEconomico.id !== (novoGrupo && novoGrupo.id)) {
			this.modelo.tamanho = null
		}
	}

	@Watch('modelo.tamanho.id')
	onTrocarTamanhoSelecionado() {
		const tamanho = this.modelo && this.modelo.tamanho
		this.tamanhoOriginalSelecionado = (tamanho && tamanho.id) ? { ...tamanho } : null
	}

	get tamanhoFoiModificado(): boolean {
		const t = this.modelo && this.modelo.tamanho
		const o = this.tamanhoOriginalSelecionado
		if (!t || !t.id || !o) return false
		return t.descricao !== o.descricao
			|| !!t.impressaoUnica !== !!o.impressaoUnica
			|| Number(t.larguraPagina) !== Number(o.larguraPagina)
			|| Number(t.alturaPagina) !== Number(o.alturaPagina)
			|| Number(t.larguraEtiqueta) !== Number(o.larguraEtiqueta)
			|| Number(t.alturaEtiqueta) !== Number(o.alturaEtiqueta)
			|| Number(t.distanciaEntreEtiquetas) !== Number(o.distanciaEntreEtiquetas)
			|| Number(t.bordaDoTopo) !== Number(o.bordaDoTopo)
			|| Number(t.bordaEsquerda) !== Number(o.bordaEsquerda)
	}

	tentarAvancarParaLayout() {
		if (this.tamanhoFoiModificado && this.modelo && this.modelo.tamanho) {
			this.acaoSobrescritaDeTamanho = 'copia'
			this.nomeDaCopiaDeTamanho = `${this.modelo.tamanho.descricao} (cópia)`
			this.dialogoDeSobrescritaDeTamanho = true
			return
		}
		this.etapa = '2'
	}

	confirmarSobrescritaDeTamanho() {
		if (!this.modelo || !this.modelo.tamanho || !this.podeEditarTamanhoDeEtiqueta) return
		if (this.acaoSobrescritaDeTamanho === 'copia') {
			if (!this.nomeDaCopiaDeTamanho || !this.nomeDaCopiaDeTamanho.trim()) return
			this.modelo.tamanho = { ...this.modelo.tamanho, id: '', descricao: this.nomeDaCopiaDeTamanho.trim() }
		}
		this.dialogoDeSobrescritaDeTamanho = false
		this.etapa = '2'
	}

	cancelarSobrescritaDeTamanho() {
		this.dialogoDeSobrescritaDeTamanho = false
	}

	get etapa1Valida(): boolean {
		if (!this.modelo) return false
		if (!this.modelo.descricao || !this.modelo.descricao.trim()) return false
		if (!this.modelo.grupoEconomico) return false

		const tamanho = this.modelo.tamanho
		if (!tamanho) return false
		if (!tamanho.descricao || !tamanho.descricao.trim()) return false
		if (!tamanho.impressaoUnica && (!(tamanho.larguraPagina > 0) || !(tamanho.alturaPagina > 0))) return false
		if (!(tamanho.larguraEtiqueta > 0) || !(tamanho.alturaEtiqueta > 0)) return false
		if (tamanho.distanciaEntreEtiquetas === null || tamanho.distanciaEntreEtiquetas === undefined || tamanho.distanciaEntreEtiquetas < 0) return false
		if (tamanho.bordaDoTopo === null || tamanho.bordaDoTopo === undefined || tamanho.bordaDoTopo < 0) return false
		if (tamanho.bordaEsquerda === null || tamanho.bordaEsquerda === undefined || tamanho.bordaEsquerda < 0) return false

		return true
	}

	get gridColunas(): number {
		const tamanho = this.modelo?.tamanho
		if (!tamanho) return 0
		if (tamanho.impressaoUnica) return 1
		const passo = (tamanho.larguraEtiqueta || 0) + (tamanho.distanciaEntreEtiquetas || 0)
		if (passo <= 0) return 0
		const disponivel = (tamanho.larguraPagina || 0) - (tamanho.bordaEsquerda || 0) + (tamanho.distanciaEntreEtiquetas || 0)
		return Math.max(0, Math.floor(disponivel / passo))
	}

	get gridLinhas(): number {
		const tamanho = this.modelo?.tamanho
		if (!tamanho) return 0
		if (tamanho.impressaoUnica) return 1
		const passo = (tamanho.alturaEtiqueta || 0) + (tamanho.distanciaEntreEtiquetas || 0)
		if (passo <= 0) return 0
		const disponivel = (tamanho.alturaPagina || 0) - 2 * (tamanho.bordaDoTopo || 0) + (tamanho.distanciaEntreEtiquetas || 0)
		return Math.max(0, Math.floor(disponivel / passo))
	}

	get etiquetasPorPagina(): number {
		return this.gridColunas * this.gridLinhas
	}

	get etiquetaCabeNaPagina(): boolean {
		const tamanho = this.modelo?.tamanho
		if (!tamanho) return true
		if (tamanho.impressaoUnica) return true
		return (tamanho.larguraEtiqueta || 0) + (tamanho.bordaEsquerda || 0) <= (tamanho.larguraPagina || 0)
			&& (tamanho.alturaEtiqueta || 0) + 2 * (tamanho.bordaDoTopo || 0) <= (tamanho.alturaPagina || 0)
	}

	get escalaDaPagina(): number {
		const tamanho = this.modelo?.tamanho
		if (!tamanho || !tamanho.larguraPagina || !tamanho.alturaPagina) return 1
		return Math.min(
			LARGURA_MAXIMA_DA_PREVIA_PX / tamanho.larguraPagina,
			ALTURA_MAXIMA_DA_PREVIA_PX / tamanho.alturaPagina,
		)
	}

	get estiloDaPagina() {
		const tamanho = this.modelo?.tamanho
		if (!tamanho) return {}
		const escala = this.escalaDaPagina
		return {
			width: `${(tamanho.larguraPagina || 0) * escala}px`,
			height: `${(tamanho.alturaPagina || 0) * escala}px`,
			position: 'relative',
		}
	}

	get celulasDeVisualizacao() {
		const tamanho = this.modelo?.tamanho
		if (!tamanho) return []
		const escala = this.escalaDaPagina
		const colunas = Math.min(this.gridColunas, 6)
		const linhas = Math.min(this.gridLinhas, 5)
		const celulas: Record<string, string>[] = []
		for (let linha = 0; linha < linhas; linha++) {
			for (let coluna = 0; coluna < colunas; coluna++) {
				const x = tamanho.impressaoUnica ? 0 : (tamanho.bordaEsquerda || 0) + coluna * ((tamanho.larguraEtiqueta || 0) + (tamanho.distanciaEntreEtiquetas || 0))
				const y = tamanho.impressaoUnica ? 0 : (tamanho.bordaDoTopo || 0) + linha * ((tamanho.alturaEtiqueta || 0) + (tamanho.distanciaEntreEtiquetas || 0))
				celulas.push({
					position: 'absolute',
					left: `${x * escala}px`,
					top: `${y * escala}px`,
					width: `${(tamanho.larguraEtiqueta || 0) * escala}px`,
					height: `${(tamanho.alturaEtiqueta || 0) * escala}px`,
				})
			}
		}
		return celulas
	}

	async salvar() {
		if (!this.modelo) return
		if (!this.form.validate()) return
		try {
			if (!this.modelo.tamanho) {
				AlertModule.setError('Obrigatório configurar um tamanho de etiqueta')
				return
			}
			if (!this.modelo.campos || this.modelo.campos.length === 0) {
				AlertModule.setError('Adicione ao menos um campo ao modelo')
				return
			}
			this.salvando = true

			const modeloSalvo = !this.modelo.id
				? await this.modeloDeEtiquetaUseCase.createModeloDeEtiqueta(this.modelo)
				: await this.modeloDeEtiquetaUseCase.updateModeloDeEtiqueta(this.modelo.id, this.modelo)

			this.$emit('confirmado', modeloSalvo)
			this.mostra = false
			AlertModule.setSuccess('Modelo de etiqueta salvo com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.$emit('sucesso')
		}
	}

}
